<template>
<!-- 姓名首字母大写组件 -->
  <div>
    <div :style="{width: width + 'px' , height: height+'px'}" class="initial">
      <span :style="{lineHeight:height+'px',fontSize:size+'px'}">{{bigName}}</span>
    </div>
  </div>
</template>

<script>
// import { pinyin } from 'pinyin-pro'
export default {
  name: "Big",
  components: {},
  props: {
    //   传入任意名字
      big:{
        type:String,
        default: '空',
        require:true
      },
      // 传入宽度
      width:{
        type:String
      },
      // 传入高度
      height:{
        type:String
      },
      //传入字体大小
      size:{
        type:String
      }
  },
  data() {
    return {
        bigName:''
    };
  },
  computed: {},
  watch: {
    // 监视该字符串,发生改变立即执行
    big:{
      immediate:true,
      handler(){
        this.bigName = this.bigNames(this.big)
      }

    }
  },
  created() { 

  },
  mounted() {},
  methods: {
    // 格式化名称 汉字
    bigNames(compellation){
      // let s =  pinyin(compellation,{ pattern: 'first', toneType: 'none' })? pinyin(compellation,{ pattern: 'first', toneType: 'none' }).toUpperCase() : ''
      // let str = s.replace(/\s*/g,"");
      if(compellation.length <= 0) return
      return compellation.slice(compellation.length-2,compellation.length)
    },
    // 格式化名称 拼音
    // bigNames(compellation){
    //   console.log(compellation)
    //   let s =  pinyin(compellation,{ pattern: 'first', toneType: 'none' })? pinyin(compellation,{ pattern: 'first', toneType: 'none' }).toUpperCase() : ''
    //   let str = s.replace(/\s*/g,"");
    //   return str.slice(str.length-2,str.length)
    // },
  },
};
</script>

<style scoped lang="scss">
.initial {
  background: #1876f0;
  border-radius: 50%;
  text-align: center;
  & span {
    color: rgba($color: #ffffff, $alpha: 93%);
    // text-shadow: 4px 0px 1px #042073;
  }
}
</style>
